/* Vapor95 performance helpers (2026-10-11). Loaded by layout/theme.liquid.
   Nothing here changes how the site looks while you're looking at it:
   1. Sliders with auto-scroll / autoplay (Splide, kept in window.slideshows by the theme) only run while on screen.
      The theme's testimonials row auto-scrolled on every frame forever, keeping phones busy the whole visit.
   2. Endless CSS animations (gel button flow, size glow, Clippy) pause while their section is off screen. */
(function () {
  "use strict";
  if (!("IntersectionObserver" in window)) return;

  // ---- 1. sliders ----
  function sliderFor(root) {
    var s = window.slideshows && root.id && window.slideshows[root.id];
    return s && s.Components ? s : null;
  }
  function setSlider(root, on) {
    var s = sliderFor(root);
    if (!s) return;
    var auto = s.Components.AutoScroll, play = s.Components.Autoplay;
    try {
      if (auto && s.options.autoScroll && s.options.autoScroll.autoStart !== false) {
        if (on && auto.isPaused && auto.isPaused()) auto.play();
        if (!on && auto.isPaused && !auto.isPaused()) auto.pause();
      }
      if (play && s.options.autoplay) {
        if (on && play.isPaused && play.isPaused()) play.play();
        if (!on && play.isPaused && !play.isPaused()) play.pause();
      }
    } catch (e) {}
  }
  var sliderIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { setSlider(e.target, e.isIntersecting); });
  }, { rootMargin: "100px 0px" });

  // ---- 2. CSS animations: a class on off-screen sections, paused by the rule below ----
  var css = document.createElement("style");
  css.textContent = ".v95-offscreen, .v95-offscreen * { animation-play-state: paused !important; }";
  document.head.appendChild(css);
  var secIO = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { e.target.classList.toggle("v95-offscreen", !e.isIntersecting); });
  }, { rootMargin: "150px 0px" });

  var seen = new WeakSet();
  function scan() {
    var roots = document.querySelectorAll(".splide[id]");
    for (var i = 0; i < roots.length; i++) if (!seen.has(roots[i])) { seen.add(roots[i]); sliderIO.observe(roots[i]); }
    var secs = document.querySelectorAll("main .shopify-section, .shopify-section-group-footer-group");
    for (var j = 0; j < secs.length; j++) if (!seen.has(secs[j])) { seen.add(secs[j]); secIO.observe(secs[j]); }
  }
  // sliders mount after the theme's islands load, possibly after we first looked: re-observing makes the
  // observer report each slider's current visibility again, so a mounted, off-screen slider gets paused
  function recheck() {
    scan();
    var roots = document.querySelectorAll(".splide[id]");
    for (var i = 0; i < roots.length; i++) { sliderIO.unobserve(roots[i]); sliderIO.observe(roots[i]); }
  }
  scan();
  window.addEventListener("load", function () { recheck(); setTimeout(recheck, 2500); setTimeout(recheck, 6000); });
  document.addEventListener("shopify:section:load", scan);
})();
